import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {CheckmarkIcon} from 'shells/icon/svg/checkmark-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

// @ts-expect-error
import loginData from './login';
import type {LoginData} from './new-login-layout';

import styles from './whats-new.module.css';

export function WhatsNew() {
    const data: LoginData = loginData;

    return (
        <div className={styles['whats-new']}>
            <StackLegacy spacing={16}>
                <Body size='xlarge' isBold={true}>
                    {data.featureSectionTitle}
                </Body>
                <StackLegacy spacing={8}>
                    {data.features.map((feature) => (
                        <div className='flex align-center gap-12' key={feature.text}>
                            <CheckmarkIcon color={colors.orange} size={20} />
                            <Link href={feature.url} newTab={true}>
                                <Body size='xlarge'>{feature.text}</Body>
                            </Link>
                        </div>
                    ))}
                </StackLegacy>
                {readMoreTextWithLink(
                    data.readMore.fullText,
                    data.readMore.linkText,
                    data.readMore.url
                )}
            </StackLegacy>
        </div>
    );
}

// Dynamically link only the specified section of text
function readMoreTextWithLink(fullText: string, linkText: string, url: string): React.ReactElement {
    const linkIndex = fullText.indexOf(linkText);

    if (linkIndex === -1) {
        // If linkText is not found, just return the full text as the link
        return (
            <Link href={url} size='xlarge' newTab={true} className='underline' isBold={true}>
                {fullText}
            </Link>
        );
    }

    const beforeLink = fullText.substring(0, linkIndex);
    const afterLink = fullText.substring(linkIndex + linkText.length);

    return (
        <Body size='xlarge' isBold={true}>
            {beforeLink}
            <Link href={url} size='xlarge' newTab={true} isBold={true} className={styles.link}>
                {linkText}
            </Link>
            {afterLink}
        </Body>
    );
}
